export default "__VITE_ASSET__ZcQddLa1__"